<template>
  <p class="questionText">Does this increase each year?</p>

  <div
    class="btn-group w-100"
    role="group"
    aria-label="Does your final salary pension increase each year"
  >
    <radio-button
      v-for="(item, i) in getInflationItems()"
      v-bind:key="i"
      name="inflation"
      :label="item.text"
      :value="selectedValue"
      @change="changeValue"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import RadioButton from "../../../shared/components/RadioButton.vue";
import { staticData } from "@/guiide/ts/staticData";

export default defineComponent({
  name: "Inflation",
  components: {
    RadioButton
  },
  data: function() {
    return {
      selectedValue: "Linked to Inflation"
    };
  },
  methods: {
    getSelectedValue(): string {
      const value = this.mapTextToValue(this.selectedValue);
      return value;
    },
    setSelectedValue(value: string) {
      const text = this.mapValueToText(value);
      this.selectedValue = text;
    },
    changeValue: function(newValue) {
      this.selectedValue = newValue;
    },
    getInflationItems() {
      return staticData.InflationData;
    },
    mapValueToText(value: string): string {
      return this.getInflationItems().filter(id => id.value == value)[0].text;
    },
    mapTextToValue(text: string): string {
      return this.getInflationItems().filter(id => id.text == text)[0].value;
    }
  }
});
</script>

<style scoped>
.questionText {
  margin-top: 18px;
  margin-bottom: 8px;
}
</style>
